/**
 * 防抖函数
 * @param {Function} func - 要执行的函数
 * @param {Number} delay - 延迟时间，单位毫秒
 * @returns {Function} - 返回一个防抖处理后的函数
 */
export function debounce(func, delay = 300) {
  let timeoutId;
  return function(...args) {
    const context = this;
    // 清除之前的定时器
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    // 设置新的定时器
    timeoutId = setTimeout(() => {
      func.apply(context, args);
      timeoutId = null;
    }, delay);
  };
}

/**
 * 节流函数
 * @param {Function} func - 要执行的函数
 * @param {Number} limit - 限制时间，单位毫秒
 * @returns {Function} - 返回一个节流处理后的函数
 */
export function throttle(func, limit = 300) {
  let inThrottle;
  return function(...args) {
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
      }, limit);
    }
  };
}


// WEBPACK FOOTER //
// ./src/utils/throttleDebounce.js